export function formatCoins(n) {
  if (n == null) return "₹0";
  return "₹" + Number(n).toLocaleString("en-IN");
}

// Avatar/picture may be an absolute URL (Google) or a relative /api/files path (uploaded).
export function avatarUrl(picture) {
  if (!picture) return "";
  if (picture.startsWith("http")) return picture;
  return `${process.env.REACT_APP_BACKEND_URL}${picture}`;
}


const GAME_LABELS = {
  spin: ["लकी स्पिन", "Lucky Spin"], color: ["कलर प्रेडिक्शन", "Color Prediction"], dice: ["डाइस", "Dice"],
  scratch: ["स्क्रैच कार्ड", "Scratch Card"], teenpatti: ["तीन पत्ती", "Teen Patti"], andarbahar: ["अंदर बाहर", "Andar Bahar"],
  dragontiger: ["ड्रैगन टाइगर", "Dragon Tiger"], aviator: ["एविएटर", "Aviator"], bhole_spin: ["भोले डेली स्पिन", "Bhole Daily Spin"],
};
export const gameLabel = (key, lang = "hi") => (GAME_LABELS[key] ? GAME_LABELS[key][lang === "hi" ? 0 : 1] : key);
